export default __webpack_public_path__ + "static/media/download.8ca34383.svg";